export type ReadonlyContractorEndpoints = {
    readonly SaveContractor: string;
    readonly GetContractor: string;
    readonly GetContractordataById: string;
    readonly UpdateContractor: string;
    readonly DeleteContractor: string;
    readonly GetContractorList : string;
    readonly GetTechnicianList : string;

    readonly SaveTechnician: string;
    readonly GetTechnician: string;
    readonly DeleteTechnician: string;
  };
  
  const controller = 'api/Contractor'
  
  const ContractorEndpoints: ReadonlyContractorEndpoints = {
    SaveContractor: `${controller}/AddUpdateContractor`,
    SaveTechnician: `${controller}/AddUpdateTechnician`,
    GetContractor: `${controller}/GetContractors`,
    GetContractordataById: `${controller}/GetContractorById`,
    UpdateContractor: `${controller}/AddUpdateContractor`,
    GetContractorList: `${controller}`,
    DeleteContractor: `${controller}/DeleteContractor`,
    GetTechnician: `${controller}/GetTechnicians`,
    DeleteTechnician: `${controller}/DeleteTechnician`,
    GetTechnicianList: `${controller}/GetTechnician`,
  };
  

 
    export { ContractorEndpoints };
  
  